import { all, put, call, getContext, takeLatest } from 'redux-saga/effects';

import { Logger } from 'utils/Logger';

import { contactDetails } from './types';

import {
  requestFundingSearchContactDetailsSuccess,
  requestFundingSearchContactDetailsFailure,
} from './reducer';

const logger = new Logger('Saga:FundingSearch:ContactDetails');

export function* requestFundingSearchContactDetailsSaga(action) {
  const authApiService = yield getContext('authApiService');
  const routerService = yield getContext('routerService');

  try {
    const response = yield call(
      authApiService.get,
      routerService.generate('api.funding_search_contact_details.funding_search_contact_details', {
        fundingSearchId: action.fundingSearchId,
      }),
    );

    yield put(requestFundingSearchContactDetailsSuccess(action.fundingSearchId, response.data));
  } catch (error) {
    logger.error('Failed to request available search managers with the following error', error);
    yield put(requestFundingSearchContactDetailsFailure(action.fundingSearchId, error));
  }
}

export default function* searchManagerSaga() {
  return yield all([takeLatest(contactDetails.request, requestFundingSearchContactDetailsSaga)]);
}
